import jQuery from "../modules/jquery/jquery-3.6.1.min.js"
jQuery(document).ready(function($) {
	$('#faq-input').on('input' ,function(event) {
		var faqFilter = $(this).val().toUpperCase();
		if (faqFilter) {
			$('.answer').hide();
			$('.question').each(function(index, question) {
				if ($(question).text().toUpperCase().includes(faqFilter)) {
					$(question).show();
					$(question).closest('.faq-section').show();
				} else { 
					$(question).hide();
				}
			});
			$('.faq-section').each(function(index, subsection) {
				if ($(subsection).find('.question:not([style*="display: none"])').length) {
					$(subsection).show();
				} else {
					$(subsection).hide();
				}
			});
			var results = false;
			$('.faq-section').each(function(index, subsection) {
				var enabled = false;
				$(subsection).find('.question').each(function(i, el) {
					if ($(subsection).is(':visible')) {
						enabled = true;
						results = true;
					}
				});
				//Show or hide the subsection
				if (enabled == true) {
					$(subsection).show();
				} else {
					$(subsection).hide();
				}
				//Show or hide the no results section 
				if (results == false) {
					$('.faq-no-results').show(); 
				} else {
					$('.faq-no-results').hide();
				}
			});
		} else {
			$('.faq-section').show();
			$('.question').show();
			$('.faq-no-results').hide()
		}
	});
});